import React, { useContext } from "react";
import { createPortal } from "react-dom";

// MUI
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTheme } from "@mui/material/styles";

// MUI Icons
import CloseIcon from '@mui/icons-material/Close';

// Custom
import MapContext, { MapContextType } from "@/context/MapContext/MapContext"

// Types
import { FrameDimensions } from '@/components/useMapPrint';

interface PrintOverlayProps {
  frameDimensions: FrameDimensions;
  onClose?: () => void;
}

const PrintOverlay: React.FC<PrintOverlayProps> = ({ frameDimensions, onClose }) => {
  const mapContext = useContext<MapContextType | null>(MapContext);

  const theme = useTheme();

  const target = (mapContext && mapContext?.map !== null) ? mapContext?.map.getTargetElement() : null;

  if (!target) return null;

  const paddingLeftPx = 250;

  return createPortal(
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 0,
        pointerEvents: "none",
      }}
    >
      {/* Frame */}
      <Box
        className="paper-frame"
        sx={{
          position: "absolute",
          top: "50%",
          left: `calc(50% + ${paddingLeftPx}px)`,
          transform: "translate(-50%, -50%)",
          border: `1px solid ${theme.palette.primary.main}`,
          width: frameDimensions.paperWidthPx,
          height: frameDimensions.paperHeightPx,
          // backgroundColor: "transparent",
          pointerEvents: "none",
          backdropFilter: "brightness(1.6)",
          zIndex: -1,
        }}
        onClick={onClose}
      />
      <Box
        className="frame"
        sx={{
          position: "absolute",
          top: "50%",
          left: `calc(50% + ${paddingLeftPx}px)`,
          transform: "translate(-50%, -50%)",
          border: `3px solid ${theme.palette.primary.main}`,
          width: frameDimensions.widthPx,
          height: frameDimensions.heightPx,
          backgroundColor: "transparent",
          pointerEvents: "none",
          backdropFilter: "brightness(0.9)",
          zIndex: -1,
        }}
        onClick={onClose}
      />
      <Button
        variant="contained"
        size="small"
        sx={{
          position: "absolute",
          top: `calc(50% - ${parseFloat(frameDimensions.paperHeightPx.toString()) / 2}px - 15px)`,
          left: `calc(50% + ${paddingLeftPx + (parseFloat(frameDimensions.paperWidthPx.toString()) / 2) - 15}px)`,
          minWidth: "24px",
          width: "24px",
          height: "24px",
          borderRadius: "50%",
          padding: 2,
          zIndex: 2002,
          pointerEvents: "auto",
        }}
        onClick={onClose}
      >
        <CloseIcon fontSize="small" />
      </Button>
    </Box>,
    target
  );
};

export default PrintOverlay;